<form
  class="password-form"
  (ngSubmit)="handleSave()"
  [formGroup]="accountPasswordForm"
>
  @if (isLoading) {
    <app-loader></app-loader>
  }

  <section class="settings-card">
    <div class="section-copy">
      <span class="section-kicker">Security</span>
      <h3>Password</h3>
      <p>Please enter your current password before setting a new password.</p>
    </div>

    <div class="password-fields">
      <label class="field">
        <span>Current Password *</span>
        <input
          [type]="showCurrentPassword ? 'text' : 'password'"
          formControlName="current_password"
          placeholder="••••••••"
          [class.is-invalid]="isInvalid('current_password')"
        />

        <button
          type="button"
          (click)="showCurrentPassword = !showCurrentPassword"
        >
          {{ showCurrentPassword ? "Hide" : "Show" }}
        </button>

        @if (isInvalid("current_password")) {
          <small>Current password is required.</small>
        }
      </label>

      <label class="field">
        <span>New Password *</span>
        <input
          [type]="showNewPassword ? 'text' : 'password'"
          formControlName="new_password"
          placeholder="••••••••"
          [class.is-invalid]="isInvalid('new_password')"
        />

        <button type="button" (click)="showNewPassword = !showNewPassword">
          {{ showNewPassword ? "Hide" : "Show" }}
        </button>

        <small class="hint"> Must be at least 8 characters. </small>

        @if (isInvalid("new_password")) {
          <small>New password must be at least 8 characters.</small>
        }
      </label>

      <label class="field">
        <span>Confirm New Password *</span>
        <input
          [type]="showConfirmPassword ? 'text' : 'password'"
          formControlName="confirm_password"
          placeholder="••••••••"
          [class.is-invalid]="
            isInvalid('confirm_password') || !isPasswordMatch()
          "
        />

        <button
          type="button"
          (click)="showConfirmPassword = !showConfirmPassword"
        >
          {{ showConfirmPassword ? "Hide" : "Show" }}
        </button>

        @if (isInvalid("confirm_password")) {
          <small>Confirm password is required.</small>
        }

        @if (!isPasswordMatch()) {
          <small>New password and confirm password must match.</small>
        }
      </label>
    </div>
  </section>

  <div class="form-footer">
    <button type="button" class="light-btn" (click)="resetForm()">
      Cancel
    </button>

    <button type="submit" class="dark-btn" [disabled]="isLoading">
      {{ isLoading ? "Saving..." : "Save Changes" }}
    </button>
  </div>
</form>
